import { useEffect, useState } from 'react'

export const usePageFullyLoaded = () => {
  const [isPageFullyLoaded, setIsPageFullyLoaded] = useState(
    () => typeof document !== 'undefined' && document.readyState === 'complete'
  )

  useEffect(() => {
    if (isPageFullyLoaded) {
      return
    }

    const handleLoad = () => {
      setIsPageFullyLoaded(true)
    }

    window.addEventListener('load', handleLoad)

    return () => {
      window.removeEventListener('load', handleLoad)
    }
  }, [isPageFullyLoaded])

  return isPageFullyLoaded
}
